import { FC, useState } from 'react'
import { Typography, Checkbox } from '@mui/material'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { closeModal, modalPropsSelector } from 'store/modals/modalSlice'
import ThemeButton from 'ui/components/buttons/primary/ThemeButton'
import { ActivateCpiWrapper } from './activateCpi.styles'
import { hideActivateCpi } from './activateCpiStorage'

const ActivateCpi: FC = () => {
  const dispatch = useAppDispatch()
  const modalProps = useAppSelector(modalPropsSelector)
  const [dontShowAgain, setDontShowAgain] = useState(false)
  const [loading, setLoading] = useState(false)

  const cpiDisplayName = modalProps?.props?.cpiDisplayName || ''
  const cpiName = modalProps?.props?.cpiName || ''

  const handleClose = () => {
    dispatch(closeModal())
  }

  const handleActivate = async () => {
    setLoading(true)
    try {
      if (modalProps?.props?.activateCpiCallback) {
        await modalProps.props.activateCpiCallback()
      }
      if (dontShowAgain && cpiName) {
        hideActivateCpi(cpiName)
      }
      handleClose()
    } catch (err) {
      console.error('Error activating CPI:', err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <ActivateCpiWrapper>
      <div className="modal-header">
        <div className="header-top">
          <div className="close-placeholder" />
          <Typography className="header-title">Activating {cpiDisplayName}</Typography>
          <svg className="close-button" onClick={handleClose} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 18L18 6M6 6L18 18" stroke="#E9E0E4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <Typography className="header-description">
          This CPI will be enabled using default data sources. You can customize the settings later on the dedicated CPI
          page.
        </Typography>
      </div>

      <div className="dont-show-again">
        <Checkbox
          checked={dontShowAgain}
          onChange={(e) => setDontShowAgain(e.target.checked)}
          icon={
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.60059 2.10156H10.4006C12.3336 2.10156 13.9006 3.66857 13.9006 5.60156V10.4016C13.9006 12.3346 12.3336 13.9016 10.4006 13.9016H5.60059C3.66759 13.9016 2.10059 12.3346 2.10059 10.4016V5.60156C2.10059 3.66857 3.66759 2.10156 5.60059 2.10156Z"
                stroke="#E9E0E4"
                strokeLinecap="round"
              />
            </svg>
          }
          checkedIcon={
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.00049 8.50159L7.32798 10.8291C7.41723 10.9183 7.56581 10.9036 7.63581 10.7986L11.2505 5.37659M5.60059 2.10156H10.4006C12.3336 2.10156 13.9006 3.66857 13.9006 5.60156V10.4016C13.9006 12.3346 12.3336 13.9016 10.4006 13.9016H5.60059C3.66759 13.9016 2.10059 12.3346 2.10059 10.4016V5.60156C2.10059 3.66857 3.66759 2.10156 5.60059 2.10156Z"
                stroke="#E9E0E4"
                strokeLinecap="round"
              />
            </svg>
          }
        />
        <Typography className="dont-show-label">Don't show this message again</Typography>
      </div>

      <div className="modal-actions">
        <ThemeButton themevariant="secondary" shape="rectangular" onClick={handleClose} sx={{ flex: 1 }} disabled={loading}>
          Cancel
        </ThemeButton>
        <ThemeButton themevariant="primary" shape="rectangular" onClick={handleActivate} sx={{ flex: 1 }} disabled={loading}>
          Activate CPI
        </ThemeButton>
      </div>
    </ActivateCpiWrapper>
  )
}

export default ActivateCpi
